import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.fadedGreen,
  textColorDark: colors.darkNight,
  textColorLight: colors.white,
  cardRadius: '20px'
};
export default fiftyFiftyCard;